/**
 * @param {number} id Video ID
 */
export const getVideoUrl = (id:string):string => 
	`//saxobank.23video.com/13846859.ihtml/player.html?source=embed&photo%5fid=${id}`;

/**
 * Get Image URL of the QR code for a given URI
 * @param {URL} uri
 * @param {number} size
 */
export const getQrCode = (uri:string, size:number = 4):string =>
	`/mediagenerator/getqrcodeforsaxouri?saxoUri=${uri}&size=${size}`;

export default { getVideoUrl, getQrCode };
